<template>
	<div>
		<div class="mb2 fw6 fs4">{{ label }}</div>
		<div class="flex">
			<div class="mr1">
				<label class="fs3 c6 fw6 mb1">
					{{ $t("from") }}
					<span class="c6--l3">(DD/MM/YYYY)</span>
				</label>
				<j-base-date-picker-simple :value="value.after" @input="dateFrom = $event" />
			</div>
			<div class="ml1">
				<label class="fs3 c6 fw6 mb1">
					{{ $t("to") }}
					<span class="c6--l3">(DD/MM/YYYY)</span>
				</label>
				<j-base-date-picker-simple :value="value.before" @input="dateTo = $event" />
			</div>
		</div>
	</div>
</template>

<script>
import JBaseDatePickerSimple from "@/components/JBaseDatePickerSimple"

export default {
	components: {
		JBaseDatePickerSimple
	},

	props: {
		value: Object,
		label: String
	},

	data() {
		return {
			dateFrom: null,
			dateTo: null
		}
	},

	watch: {
		dateFrom: {
			handler() {
				this.$emit("input", {
					type: "between",
					after: this.dateFrom,
					before: this.dateTo
				})
			}
		},
		dateTo: {
			handler() {
				this.$emit("input", {
					type: "between",
					after: this.dateFrom,
					before: this.dateTo
				})
			}
		}
	}
}
</script>